import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import BlueAddCart from '@/components/BlueAction/AddToCartButton.vue';
export default defineComponent({
    name: 'sticky-cta-button',
    components: { BlueAddCart },
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
    methods: {},
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
// eslint-disable-next-line no-undef
$(window).on('scroll', function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    // eslint-disable-next-line no-undef
    if ($('.JS_blueCtaButton').isInViewport()) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        // eslint-disable-next-line no-undef
        $('.JS_blueCtaButtonSticky, .JS_blueStickyBoxFadeOut').fadeOut();
    }
    else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        // eslint-disable-next-line no-undef
        $('.JS_blueCtaButtonSticky, .JS_blueStickyBoxFadeOut').fadeIn();
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    // eslint-disable-next-line no-undef
    $('.JS_stickyPriceDetailLink').on('click', function (e) {
        e.preventDefault();
        const html = '<span class="small d-block"><strong>Preis inkl. MwSt. zzgl. Versand</strong><br>' +
            'Wähle zwischen Standardversand (3,99 € oder kostenlos ab 30 € Warenwert) oder Expressversand (6,99 €)<br>' +
            'Artikel wird nach §25a UStG. differenzbesteuert</span>';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        // eslint-disable-next-line no-undef
        renderAsModal(html);
    });
});
